import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type LoadingType = 'default' | 'spinner';

@Component({
  selector: 'k-loading',
  imports: [ NgClass ],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent {
  type = input<LoadingType>('default');
  size = input<'small' | 'medium' | 'large'>('medium');
}
